<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          View Onboarding Request</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>

    <app-timeline>
      <app-timeline-item class="pb-1">
        <b-row>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <dl class="row">
              <dt class="col-sm-12 dt-text">
                Consultant
              </dt>
              <dd class="col-sm-12">
                <span
                  class="form-control"
                  v-text="onboarding.employee_name"
                />
              </dd>
            </dl>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <dl class="row">
              <dt class="col-sm-12 dt-text">
                Due Date
              </dt>
              <dd class="col-sm-12">
                <span
                  class="form-control"
                  v-text="onboarding.due_date"
                />
              </dd>
            </dl>
          </b-col>
          <b-col
            cols="12"
            md="8"
          >
            <dl class="row">
              <dt class="col-sm-12 dt-text">
                Onboarding Items
              </dt>
              <dd class="col-sm-12">
                <div class="d-none d-lg-flex">
                  <b-row class="flex-grow-1 px-1">
                    <b-col
                      cols="12"
                      lg="5"
                    >
                      <label>Item Name</label>
                    </b-col>
                    <b-col
                      cols="12"
                      lg="4"
                    >
                      <label>Complete Date</label>
                    </b-col>
                    <b-col
                      cols="12"
                      lg="3"
                    >
                      <label>Status</label>
                    </b-col>
                  </b-row>
                </div>
                <div class="border rounded p-50">
                  <b-row
                    v-for="(item, index) in onboarding.items"
                    :key="index"
                    class="flex-grow-1 px-1 py-50"
                  >
                    <b-col
                      cols="12"
                      lg="5"
                    >
                      <span
                        class="form-control"
                        v-text="item.item_name"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      lg="4"
                      class="pl-50"
                    >
                      <span
                        class="form-control"
                        v-text="item.complete_date"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      lg="3"
                      class="pl-50"
                    >
                      <span
                        class="form-control"
                        v-text="item.status"
                      />
                    </b-col>
                  </b-row>
                </div>
              </dd>
            </dl>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <dl class="row mt-md-2">
              <dt class="col-sm-12 dt-text">
                Status
              </dt>
              <dd class="col-sm-12">
                <span
                  class="form-control"
                  v-text="onboarding.status"
                />
              </dd>
            </dl>
          </b-col>
        </b-row>
      </app-timeline-item>

      <app-timeline-item
        variant="danger"
        class="pb-1"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>Documents</h6>
        </div>
        <b-row
          v-if="onboarding.documents !== null"
          class="mt-1"
        >
          <b-col cols="12">
            <b-link
              v-for="option in onboarding.documents"
              :key="option.id"
              :value="option.id"
              :href="option.attachment_link"
              :title="option.name"
              target="_blank"
              :class="{'mt-75': option}"
            >
              <b-badge
                variant="primary"
                class="mr-1 mb-50"
              >
                <span>{{ option.name }}</span>
              </b-badge>
            </b-link>
          </b-col>
        </b-row>
        <div
          v-if="onboarding.documents.length == 0"
          class="text-center"
        >
          <p class="mb-0">
            No Documents available
          </p>
        </div>
      </app-timeline-item>

      <app-timeline-item
        variant="primary"
        class="pb-1"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>Comments</h6>
        </div>
        <b-row>
          <b-col
            v-for="comment in onboarding.comments"
            :key="comment"
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              <span class="d-block"><small>Commented on {{ comment.date_text }} {{ comment.time }}</small></span>
              <b-form-textarea
                v-model="comment.comment"
                rows="2"
                disabled
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div
          v-if="onboarding.comments.length == 0"
          class="text-center"
        >
          <p class="mb-0">
            No Comments available
          </p>
        </div>
      </app-timeline-item>

      <app-timeline-item
        v-show="onboarding.user_defined_fields.length !== 0"
        variant="secondary"
        class="pb-1"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>User Defined Fields</h6>
        </div>
        <b-row>
          <b-col
            v-for="field in onboarding.user_defined_fields"
            :id="field.id"
            :key="field.id"
            cols="12"
            md="6"
            lg="4"
          >
            <dl class="row">
              <dt class="col-sm-12 dt-text">
                {{ field.name }}
              </dt>
              <dd class="col-sm-12">
                <span
                  class="form-control"
                  v-text="field.value"
                />
              </dd>
            </dl>
          </b-col>
        </b-row>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import Onboarding from '@/js/onboarding'

import {
  BCard, BRow, BCol, BButton, BFormGroup, BFormTextarea, BBadge, BLink,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  name: 'OnBoardingView',
  components: {
    BCard,
    AppTimeline,
    AppTimelineItem,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormTextarea,
    BBadge,
    BLink,
  },
  directives: {
  },
  setup() {
  },
  data() {
    return {
      onboarding: {},
    }
  },
  mounted() {
  },
  created() {
    Onboarding.getOnboardingById(this, this.$route.params.id)
  },
  methods: {
    setOnboarding(onboarding) {
      this.onboarding = onboarding
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
